const Countries = {
    country_list: [
        {
            "label": "United States",
            "id": 3,
            "value": "1"
        },
        {
            "label": "Australia",
            "id": 1,
            "value": "61"
        },
        {
            "label": "United Kingdom",
            "id": 2,
            "value": "44"
        },
        {
            "label": "Germany",
            "id": 13,
            "value": "49"
        },
        {
            "label": "France",
            "id": 12,
            "value": "33"
        },
        {
            "label": "India",
            "id": 80,
            "value": "91"
        },
        {
            "label": "Albania",
            "id": 18,
            "value": "355"
        },
        {
            "label": "Algeria",
            "id": 63,
            "value": "213"
        },
        {
            "label": "Andorra",
            "id": 19,
            "value": "376"
        },
        {
            "label": "Angola",
            "id": 132,
            "value": "244"
        },
        {
            "label": "Argentina",
            "id": 95,
            "value": "54"
        },
        {
            "label": "Armenia",
            "id": 20,
            "value": "374"
        },
        {
            "label": "Austria",
            "id": 10,
            "value": "43"
        },
        {
            "label": "Azerbaijan",
            "id": 21,
            "value": "994"
        },
        {
            "label": "Bahamas",
            "id": 149,
            "value": "1242"
        },
        {
            "label": "Bahrain",
            "id": 64,
            "value": "973"
        },
        {
            "label": "Bangladesh",
            "id": 159,
            "value": "880"
        },
        {
            "label": "Barbados",
            "id": 155,
            "value": "1246"
        },
        {
            "label": "Belarus",
            "id": 22,
            "value": "375"
        },
        {
            "label": "Belgium",
            "id": 11,
            "value": "32"
        },
        {
            "label": "Benin",
            "id": 102,
            "value": "229"
        },
        {
            "label": "Bolivia",
            "id": 105,
            "value": "591"
        },
        {
            "label": "Bosnia and Herzegovina",
            "id": 23,
            "value": "387"
        },
        {
            "label": "Botswana",
            "id": 116,
            "value": "267"
        },
        {
            "label": "Brazil",
            "id": 81,
            "value": "55"
        },
        {
            "label": "Bulgaria",
            "id": 24,
            "value": "359"
        },
        {
            "label": "Burkina Faso",
            "id": 144,
            "value": "226"
        },
        {
            "label": "Cambodia",
            "id": 83,
            "value": "855"
        },
        {
            "label": "Cameroon",
            "id": 106,
            "value": "237"
        },
        {
            "label": "Canada",
            "id": 9,
            "value": "1"
        },
        {
            "label": "Chile",
            "id": 101,
            "value": "56"
        },
        {
            "label": "China",
            "id": 6,
            "value": "86"
        },
        {
            "label": "Colombia",
            "id": 82,
            "value": "57"
        },
        {
            "label": "Congo Brazzaville",
            "id": 135,
            "value": "242"
        },
        {
            "label": "Costa Rica",
            "id": 117,
            "value": "506"
        },
        {
            "label": "Croatia",
            "id": 25,
            "value": "385"
        },
        {
            "label": "Cyprus",
            "id": 26,
            "value": "357"
        },
        {
            "label": "Czechia",
            "id": 27,
            "value": "420"
        },
        {
            "label": "Congo, the Democratic Republic of the",
            "id": 134,
            "value": "243"
        },
        {
            "label": "Denmark",
            "id": 28,
            "value": "45"
        },
        {
            "label": "Djibouti",
            "id": 131,
            "value": "253"
        },
        {
            "label": "Dominica",
            "id": 161,
            "value": "1767"
        },
        {
            "label": "Dominica New",
            "id": 162,
            "value": "1767"
        },
        {
            "label": "Ecuador",
            "id": 156,
            "value": "593"
        },
        {
            "label": "Egypt",
            "id": 65,
            "value": "20"
        },
        {
            "label": "El Salvador",
            "id": 150,
            "value": "503"
        },
        {
            "label": "Estonia",
            "id": 29,
            "value": "372"
        },
        {
            "label": "Ethiopia",
            "id": 103,
            "value": "251"
        },
        {
            "label": "Fiji",
            "id": 109,
            "value": "679"
        },
        {
            "label": "Finland",
            "id": 30,
            "value": "358"
        },
        {
            "label": "French Guiana",
            "id": 142,
            "value": "594"
        },
        {
            "label": "Gabon",
            "id": 123,
            "value": "241"
        },
        {
            "label": "Georgia",
            "id": 31,
            "value": "995"
        },
        {
            "label": "Ghana",
            "id": 113,
            "value": "233"
        },
        {
            "label": "Greece",
            "id": 32,
            "value": "30"
        },
        {
            "label": "Guadeloupe",
            "id": 141,
            "value": "590"
        },
        {
            "label": "Guatemala",
            "id": 157,
            "value": "502"
        },
        {
            "label": "Guinea",
            "id": 127,
            "value": "224"
        },
        {
            "label": "Haiti",
            "id": 97,
            "value": "509"
        },
        {
            "label": "Honduras",
            "id": 119,
            "value": "504"
        },
        {
            "label": "Hong Kong",
            "id": 7,
            "value": "852"
        },
        {
            "label": "Hungary",
            "id": 33,
            "value": "36"
        },
        {
            "label": "Iceland",
            "id": 34,
            "value": "354"
        },
        {
            "label": "Indonesia",
            "id": 57,
            "value": "62"
        },
        {
            "label": "Iran",
            "id": 111,
            "value": "98"
        },
        {
            "label": "Iraq",
            "id": 66,
            "value": "964"
        },
        {
            "label": "Ireland",
            "id": 4,
            "value": "353"
        },
        {
            "label": "Islas caiman",
            "id": 152,
            "value": "1345"
        },
        {
            "label": "Israel",
            "id": 89,
            "value": "972"
        },
        {
            "label": "Italy",
            "id": 5,
            "value": "39"
        },
        {
            "label": "Cote d'Ivoire",
            "id": 124,
            "value": "225"
        },
        {
            "label": "Jamaica",
            "id": 153,
            "value": "876"
        },
        {
            "label": "Japan",
            "id": 99,
            "value": "81"
        },
        {
            "label": "Jersey",
            "id": 35,
            "value": "12345"
        },
        {
            "label": "Jordan",
            "id": 67,
            "value": "962"
        },
        {
            "label": "Kazakhstan",
            "id": 138,
            "value": "7"
        },
        {
            "label": "Kenya",
            "id": 56,
            "value": "254"
        },
        {
            "label": "Kosovo",
            "id": 36,
            "value": "381"
        },
        {
            "label": "Kuwait",
            "id": 68,
            "value": "965"
        },
        {
            "label": "Kyrgyzstan",
            "id": 137,
            "value": "996"
        },
        {
            "label": "Latvia",
            "id": 37,
            "value": "371"
        },
        {
            "label": "Lebanon",
            "id": 69,
            "value": "961"
        },
        {
            "label": "Lesotho",
            "id": 104,
            "value": "266"
        },
        {
            "label": "Liberia",
            "id": 121,
            "value": "231"
        },
        {
            "label": "Libya",
            "id": 70,
            "value": "218"
        },
        {
            "label": "Liechtenstein",
            "id": 38,
            "value": "423"
        },
        {
            "label": "Lithuania",
            "id": 39,
            "value": "370"
        },
        {
            "label": "Luxembourg",
            "id": 40,
            "value": "352"
        },
        {
            "label": "Macau",
            "id": 158,
            "value": "853"
        },
        {
            "label": "North Macedonia",
            "id": 41,
            "value": "389"
        },
        {
            "label": "Malawi",
            "id": 114,
            "value": "265"
        },
        {
            "label": "Malaysia",
            "id": 58,
            "value": "60"
        },
        {
            "label": "Maldives",
            "id": 160,
            "value": "960"
        },
        {
            "label": "Mali",
            "id": 90,
            "value": "223"
        },
        {
            "label": "Malta",
            "id": 42,
            "value": "356"
        },
        {
            "label": "Martinique",
            "id": 140,
            "value": "596"
        },
        {
            "label": "Mauritania",
            "id": 126,
            "value": "222"
        },
        {
            "label": "Mauritius",
            "id": 112,
            "value": "230"
        },
        {
            "label": "Mexico",
            "id": 86,
            "value": "52"
        },
        {
            "label": "Moldova",
            "id": 43,
            "value": "373"
        },
        {
            "label": "Monaco",
            "id": 44,
            "value": "377"
        },
        {
            "label": "Montenegro",
            "id": 45,
            "value": "382"
        },
        {
            "label": "Morocco",
            "id": 71,
            "value": "212"
        },
        {
            "label": "Mozambique",
            "id": 96,
            "value": "258"
        },
        {
            "label": "Myanmar",
            "id": 122,
            "value": "95"
        },
        {
            "label": "Namibia",
            "id": 128,
            "value": "264"
        },
        {
            "label": "Nepal",
            "id": 139,
            "value": "977"
        },
        {
            "label": "Netherlands",
            "id": 14,
            "value": "31"
        },
        {
            "label": "New Zealand",
            "id": 8,
            "value": "64"
        },
        {
            "label": "Niger",
            "id": 145,
            "value": "227"
        },
        {
            "label": "Nigeria",
            "id": 115,
            "value": "234"
        },
        {
            "label": "Norway",
            "id": 46,
            "value": "47"
        },
        {
            "label": "Oman",
            "id": 72,
            "value": "968"
        },
        {
            "label": "Pakistan",
            "id": 148,
            "value": "92"
        },
        {
            "label": "Palestinian Territory",
            "id": 73,
            "value": "970"
        },
        {
            "label": "Panama",
            "id": 151,
            "value": "507"
        },
        {
            "label": "Peru",
            "id": 118,
            "value": "51"
        },
        {
            "label": "Philippines",
            "id": 59,
            "value": "63"
        },
        {
            "label": "Poland",
            "id": 47,
            "value": "48"
        },
        {
            "label": "Portugal",
            "id": 48,
            "value": "351"
        },
        {
            "label": "Puerto Rico",
            "id": 108,
            "value": "1"
        },
        {
            "label": "Qatar",
            "id": 74,
            "value": "974"
        },
        {
            "label": "Romania",
            "id": 49,
            "value": "40"
        },
        {
            "label": "Russia",
            "id": 88,
            "value": "7"
        },
        {
            "label": "Rwanda",
            "id": 143,
            "value": "250"
        },
        {
            "label": "San Marino",
            "id": 50,
            "value": "378"
        },
        {
            "label": "Saudi Arabia",
            "id": 75,
            "value": "966"
        },
        {
            "label": "Senegal",
            "id": 125,
            "value": "221"
        },
        {
            "label": "Serbia",
            "id": 51,
            "value": "381"
        },
        {
            "label": "Singapore",
            "id": 60,
            "value": "65"
        },
        {
            "label": "Slovakia",
            "id": 52,
            "value": "421"
        },
        {
            "label": "Slovenia",
            "id": 53,
            "value": "386"
        },
        {
            "label": "South Africa",
            "id": 85,
            "value": "27"
        },
        {
            "label": "South Korea",
            "id": 87,
            "value": "82"
        },
        {
            "label": "Spain",
            "id": 15,
            "value": "34"
        },
        {
            "label": "Sri Lanka",
            "id": 147,
            "value": "94"
        },
        {
            "label": "Sudan",
            "id": 130,
            "value": "249"
        },
        {
            "label": "Swaziland",
            "id": 129,
            "value": "268"
        },
        {
            "label": "Sweden",
            "id": 16,
            "value": "46"
        },
        {
            "label": "Switzerland",
            "id": 17,
            "value": "41"
        },
        {
            "label": "Syria",
            "id": 76,
            "value": "963"
        },
        {
            "label": "Taiwan",
            "id": 84,
            "value": "886"
        },
        {
            "label": "Tajikistan",
            "id": 120,
            "value": "992"
        },
        {
            "label": "Tanzania",
            "id": 91,
            "value": "255"
        },
        {
            "label": "Thailand",
            "id": 61,
            "value": "66"
        },
        {
            "label": "Togo",
            "id": 133,
            "value": "228"
        },
        {
            "label": "Trinidad and Tobago",
            "id": 154,
            "value": "868"
        },
        {
            "label": "Tunisia",
            "id": 77,
            "value": "216"
        },
        {
            "label": "Turkey",
            "id": 54,
            "value": "90"
        },
        {
            "label": "Uganda",
            "id": 110,
            "value": "256"
        },
        {
            "label": "Ukraine",
            "id": 55,
            "value": "380"
        },
        {
            "label": "United Arab Emirates",
            "id": 78,
            "value": "971"
        },
        {
            "label": "Uzbekistan",
            "id": 136,
            "value": "998"
        },
        {
            "label": "Venezuela",
            "id": 94,
            "value": "58"
        },
        {
            "label": "Vietnam",
            "id": 62,
            "value": "84"
        },
        {
            "label": "Yemen",
            "id": 79,
            "value": "967"
        },
        {
            "label": "Zambia",
            "id": 92,
            "value": "260"
        },
        {
            "label": "Zimbabwe",
            "id": 100,
            "value": "263"
        },
        {
            "label": "Uruguay",
            "id": 146,
            "value": "598"
        }
    ]
}

export default Countries